import './Image.css'
export default function Image(props) {
  return (
    <img
      src={props.src}
      alt={props.alt}
      className={`image${props.class ? ' ' + props.class : ''}`}
    />
  )
}